import { z } from "zod";
export const createApprovalSchema = z.object({
    companyId: z.string().uuid(),
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    requestedByAgentId: z.string().uuid().nullable().optional(),
    requestedByUserId: z.string().nullable().optional(),
});
export const decideApprovalSchema = z.object({
    decision: z.enum(["approved", "rejected"]),
    decidedByUserId: z.string().optional(),
});
//# sourceMappingURL=approval.js.map